<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <ng-container formGroupName="loan">
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-radio
                      [toggleBgEmpty]="true"
                      formControlName="loanType"
                      label="Type de crédit"
                      [options]="[
                        { value: 'FIX', label: 'Fixe' },
                        { value: 'IN_FINE', label: 'In Fine' },
                      ]"
                    >
                    </pr-input-radio>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column
                      [label]="
                        form.get('products').value[0].parameters
                          .borrowerInsuranceContext === 'CHANGE'
                          ? 'Capital restant dû'
                          : 'Montant emprunté'
                      "
                      [derrors]="derrors"
                      [suffix]="'€'"
                    >
                      <input
                        formControlName="amountBorrowed"
                        type="text"
                        placeholder="200000"
                      />
                    </pr-input-column>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column
                      [label]="
                        form.get('products').value[0].parameters
                          .borrowerInsuranceContext === 'CHANGE'
                          ? 'Durée restante à la date du changement'
                          : 'Durée totale'
                      "
                      [derrors]="derrors"
                      [suffix]="'Mois'"
                    >
                      <input
                        formControlName="durationTotalInMonth"
                        type="text"
                        placeholder="240"
                      />
                    </pr-input-column>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column
                      label="Taux d'intérêt"
                      [derrors]="derrors"
                      [suffix]="'%'"
                    >
                      <input
                        formControlName="interestRate"
                        type="text"
                        placeholder="3.8"
                      />
                    </pr-input-column>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
